import { maxADYear as e, minADYear as t } from "../../constants/calendar-date.js";
import n from "dayjs";
// src/design/forms/datepicker/calendar-engine/use-cases/english_date/is_date_valid.tsx
function r(r) {
	let i = e, a = t, o = r.split("-");
	return parseInt(o[0]) < i && parseInt(o[0]) > a && n(r, "YYYY-MM-DD", !0).isValid();
}
export { r as is_date_valid };

//# sourceMappingURL=is_date_valid.js.map